export default "__VITE_ASSET__R9M59J6A__"